export default function CreateCloudfrontUrl(path) {
    const url = "https://d2dhzsfgxco53w.cloudfront.net/" + path;

    return url;
}   
